export enum InputType {
  TEXT = 'text',
  PASSWORD = 'password',
}
